<div class="footer">
  <!-- <img src="assets/images/footer.png" alt="header" /> -->
</div>
